import React, { Component } from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PageMetadata from '../components/Generic/PageMetadata';
import Breadcrumb from '../components/Brand/Shared/Breadcrumb';
import PGDataLayer from '../components/Generic/PGDataLayer/PGDataLayer';
import { Hidden_H1_TXT, contentType, contentfulConstant } from '../constants/global';
import { defaultLangKey } from '../constants/languages';
import { renderSection, resetCollectionCardCounter } from '../utils/uiHelper';
import DOMIdentifier from '../utils/domIdentifier';
import getInitialContentfulData from '../utils/helpers/initialDataHelper';
import styles from '../components/Brand/Story/Story-tw-styles';
import { BannerBackgroundImage } from '../components/Brand/BackgroundImage';
import dynamic from 'next/dynamic';
import config from '../config';
import LazyLoad from 'react-lazy-load';
import DOMPurify from 'isomorphic-dompurify'
import FAQBlock from '../components/Brand/FAQBlock';
import Typography from '../components/Generic/Typography';

// Dynamically import CollectionCarousel with SSR disabled to prevent react-slick DOM access issues
const CollectionCarousel = dynamic(() => import('../components/Brand/ProductCarousel/CollectionCarousel'), { 
  ssr: false, 
  loading: () => null 
});

class Story extends Component {
  static propTypes = {
    pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
    contentData: PropTypes.oneOfType([PropTypes.object]).isRequired,
    router: PropTypes.oneOfType([PropTypes.object]).isRequired,
    imageurl: PropTypes.oneOfType([PropTypes.string]).isRequired,
  };

  static async getInitialProps({ query, asPath }) {
    let imageurlPath = '';
    const url = decodeURIComponent(asPath);
    if (typeof url === 'string' && url.includes('imageurl')) {
      let params = url.split('?');
      let eachParamsArr = params[1].split('&');
      let obj = {};
      if (eachParamsArr && eachParamsArr.length) {
        eachParamsArr.map(param => {
          let keyValuePair = param.split('=');
          let key = keyValuePair[0];
          let value = keyValuePair[1];
          obj[key] = value;
        });
      }
      const urlPath = 'https://pantenegrey.pgsitecore.com';
      imageurlPath = `${urlPath}${obj.imageurl}`;
    }
    let contentData = await getInitialContentfulData(
      contentfulConstant,
      contentType.contentPage,
      query.locale || defaultLangKey,
      { slug: query.slug }
    );
    return {
      contentData: contentData.data,
      pageContext: query,
      imageurl: imageurlPath,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);
    this.scrollHandler();
    const { pageContext } = this.props;
    DOMIdentifier.addClassToBody(
      'story-page',
      `${pageContext.contentfulId}-story`
    );
  }

  componentWillReceiveProps(nextProps) {
    const { pageContext } = this.props;
    if (nextProps.pageContext.contentfulId != pageContext.contentfulId) {
      // Remove added classes
      DOMIdentifier.removeClassToBody(
        'story-page',
        `${pageContext.contentfulId}-story`
      );
      // add new classes
      DOMIdentifier.addClassToBody(
        'story-page',
        `${nextProps.pageContext.contentfulId}-story`
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollHandler);
    const { pageContext } = this.props;
    DOMIdentifier.removeClassToBody(
      'story-page',
      `${pageContext.contentfulId}-story`
    );
  }
  scrollHandler = () => {
    const { contentData } = this.props;
    let pageData = contentData.contentPageCollection.items[0];
    const bannerDiv = document.getElementById('bannerStoryScroll');
    let scroll = window && Math.round(window.pageYOffset);
    let headerHeight = document.getElementById('page-header').offsetHeight;
    let breadCrumbHeight = document.getElementsByClassName(
      'breadcrumbContainer'
    )[0].offsetHeight;
    let scr = -(scroll / 10) + (headerHeight + breadCrumbHeight);
    bannerDiv && (bannerDiv.style.backgroundPositionY = scr + 'px');
    if (
      (pageData.styles === 'powerOfHairStyle' ||
        pageData.styles === 'howToStartedAll') &&
      window.innerWidth <= config.screenWidth.tabPhoneWidthEnd &&
      bannerDiv
    ) {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        bannerDiv.classList.add('MobilebannerstickyStory');
      } else {
        bannerDiv.classList.remove('MobilebannerstickyStory');
      }
    }
  };
  render() {
    const props = this.props;
    const { pageContext, contentData, router, imageurl } = this.props;
    let pageData = contentData.contentPageCollection.items[0];
    const constants = require(`../constants/messages/${pageContext.locale}`);
    let cardStyles = pageData && pageData.styles;
    resetCollectionCardCounter();
    const sectionBackground = pageData.backgroundImage
      ? {
        backgroundImage: `url("${pageData.backgroundImage &&
          pageData.backgroundImage.url}")`,
        backgroundSize: `cover`,
        backgroundRepeat: `no-repeat`
      }
      : {};
    return (
      <React.Fragment>
        {pageData && pageData.pageMetadata && (
          <PGDataLayer
            locale={props.pageContext.locale}
            pageType={contentType.contentPage}
            path={router.asPath}
            title={pageData.pageMetadata && pageData.pageMetadata.pageTitle}
          />
        )}
        {pageData.pageMetadata && (
          <PageMetadata
            title={pageData.pageMetadata.pageTitle}
            metaTitle={pageData.pageMetadata.metaTitle}
            metaDescription={
              pageData.pageMetadata.metaDescription &&
              pageData.pageMetadata.metaDescription
            }
            orgTitle={pageData.pageMetadata.openGraphPageTitle}
            orgDescription={pageData.pageMetadata.openGraphDescription}
            orgImage={
              imageurl ||
              (pageData.pageMetadata.ogImage &&
                pageData.pageMetadata.ogImage.url)
            }
            orgType="article"
            metaKeywords={
              pageData.pageMetadata.metaKeywords &&
              pageData.pageMetadata.metaKeywords
            }
            twitterImage={
              imageurl ||
              (pageData.pageMetadata.ogImage &&
                pageData.pageMetadata.ogImage.url)
            }
            twitterCard="summary_large_image"
          />
        )}
        <div className={styles.storyBreadCrumb}>
          <Breadcrumb locale={pageContext.locale} currentUrl={router.asPath} />
        </div>
        <div className={classNames(pageData && pageData.styles)}>
          <div id="mobile-style-story">
            {pageData?.isNewTemplate &&
             <h1 className='hidden'>{Hidden_H1_TXT}</h1>
             }
            {pageData &&
              pageData.bannerImageCollection &&
              pageData.bannerImageCollection.items.length > 0 && (
                <div
                  className={classNames(
                    styles.contentSections,
                    pageData.styles === 'powerOfHairStyle'
                      ? 'powerHairBanner'
                      : null
                  )}
                >
                  {pageData &&
                    pageData.bannerImageCollection &&
                    pageData.bannerImageCollection.items.length > 0 ? (
                    <div className={classNames(styles.imageWrapper)}>
                      <BannerBackgroundImage
                        data={pageData.bannerImageCollection.items[0]}
                        id="bannerStoryScroll"
                      />
                    </div>
                  ) : null}
                  <div className={classNames(styles.viewsTitleWrapper)}>
                    <div className={classNames(styles.titleWrapper)}>
                      <Typography
                        component="div"
                        className={classNames(
                          cardStyles
                            ? styles[cardStyles]
                            : styles.heroImageTitle,
                          'heroTitleId'
                        )}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(pageData.title),
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
          </div>
          <div style={sectionBackground}>
            {pageData.pageContentCollection != null &&
              pageData.pageContentCollection.items.map((sectionItem, i) => {
                return (
                  (
                    sectionItem.styles === 'Nonosection-listing' ||
                    sectionItem.styles === 'section-flex-wrap-section-look' ||
                    sectionItem.styles === 'section-p-80-100' ||
                    sectionItem.styles === 'um-cabelo-panene-diz-tudo-section-3' ||
                    sectionItem.styles === 'unidas-pelos-cachos-final-section' ||
                    sectionItem.styles === 'unidas-section-listing' ||
                    sectionItem.styles === 'SafetyFiveSection' ||
                    sectionItem.styles === 'SafetyFiveSectionMobile' ||
                    sectionItem.styles === 'SafetySixthSection' ||
                    sectionItem.styles === 'SafetyTestedSection' ||
                    sectionItem.styles === 'SafetyQualityThirdSection' ||
                    sectionItem.styles === 'RecycleThirdSection' ||
                    sectionItem.styles === 'RecycleSCStackedSection' ||
                    sectionItem.styles === 'Recyclefoursection' ||
                    sectionItem.styles === 'savewaterFourthSection' ||
                    sectionItem.styles === 'savewaterSobreBannerSectio' ||
                    sectionItem.styles === 'savewatervoicesabosection'

                  ) && i >= 2 ? (
                    <LazyLoad offset={-20}>
                      <>
                        <React.Fragment key={sectionItem.sys.id + '-' + i}>
                          {renderSection(sectionItem, pageContext, true)}
                        </React.Fragment>
                      </>
                    </LazyLoad>
                  ) : (
                    <React.Fragment key={sectionItem.sys.id + '-' + i} >
                      {renderSection(sectionItem, pageContext, false)}
                    </React.Fragment>
                  )
                );
              })}
          </div>

          {pageData.productIngredientsCollection != null &&
            pageData.productIngredientsCollection.items.map((sectionItem, i) => {
              return (
                <div key={sectionItem.sys.id + '-' + i} className={styles.ingredient.viewAllButtonWrapper}>
                  <Typography
                    component="div"
                    className={classNames(styles.ingredient.viewAllButton)}
                  >
                    <h4 className={styles.ingredient.viewAllButtonh4}>
                      {sectionItem.ingredientsTitle}
                    </h4>
                  </Typography>
                  <Typography
                    component="div"
                    className={styles.ingredient.allIngredients}
                  >
                    {sectionItem.ingredientsText}
                  </Typography>
                </div>
              )
            })
          }
          {pageData &&
            pageData.relatedCollectionsCollection &&
            pageData.relatedCollectionsCollection.items.length > 0 ? (
            <div className={classNames(styles.moreCollections.mainWrapper)}>
              <div
                className={classNames(styles.moreCollections.headingWrapper)}
              >
                <Typography
                  component="h3"
                  className={classNames(styles.moreCollections.heading)}
                >
                  {constants.relatedCollectionsHeading}
                </Typography>
              </div>

              <>
                <CollectionCarousel
                  contentData={pageData}
                  locale={pageContext.locale}
                />
              </>
            </div>
          ) : null}

          {
            pageData && pageData?.faqSectionCollection && pageData?.faqSectionCollection?.items.length > 0 ? (
              <FAQBlock faqItems={pageData.faqSectionCollection.items} />
            ) : null
          }
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Story);
